
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.91 10.182c.221 0 .434.087.59.242l2.027 2.005 4.206.001c1.654.01 3 1.29 3.095 2.904l.005.162v11.261c-.01 1.685-1.391 3.05-3.106 3.061H10.273c-1.717 0-3.106-1.374-3.106-3.066V15.496c0-1.692 1.389-3.066 3.106-3.066h4.199l2.027-2.006a.84.84 0 01.482-.235l.11-.007h6.818zm-6.196 10.607h-2.857a.863.863 0 00-.857.869v2.894c0 .48.384.868.857.868l.1-.006a.864.864 0 00.757-.862v-.3a5.075 5.075 0 003.478 1.736c2.304.16 4.427-1.27 5.174-3.483a.871.871 0 00-.533-1.103.855.855 0 00-1.089.54 3.388 3.388 0 01-3.436 2.313 3.384 3.384 0 01-2.715-1.73h1.121a.863.863 0 00.857-.867.863.863 0 00-.857-.869zm3.094-5.777c-2.304-.16-4.427 1.27-5.174 3.483a.871.871 0 00.533 1.103.855.855 0 001.089-.54 3.388 3.388 0 013.436-2.313 3.384 3.384 0 012.715 1.728l-1.121.001a.863.863 0 00-.857.868c0 .48.383.869.857.869h2.857a.863.863 0 00.857-.869v-2.894a.863.863 0 00-.857-.868l-.1.006a.864.864 0 00-.757.862v.3a5.075 5.075 0 00-3.478-1.736z","fill":"#12181D","fill-rule":"evenodd"}})])
          )
        }
      }
    